import styled from "styled-components";
export const UnitContainer = styled.div.withConfig({
  displayName: "unitstyles__UnitContainer",
  componentId: "sc-pwh3fb-0"
})(["", ""], {
  padding: "0.5rem"
});
